import { useEffect, useRef, useState } from 'react';

import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { getActiveChannel } from '@/store/slices/user/selectors';
import { fetchPasscodeLists } from '@/store/slices/audiences';

const useLoadPasscodeLists = () => {
  const activeChannel = useAppSelector(getActiveChannel);

  const [loading, setLoading] = useState(false);

  const fetching = useRef(false);

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (fetching.current || !activeChannel) {
      return;
    }

    fetching.current = true;
    setLoading(true);

    const fetch = async () => {
      try {
        await dispatch(fetchPasscodeLists(activeChannel));
      } catch (error) {
        console.error('Error fetching passcode lists:', error);
      } finally {
        setLoading(false);
        fetching.current = false;
      }
    };

    fetch();
  }, [activeChannel, dispatch]);

  return { loading };
};

export default useLoadPasscodeLists;
